import Vue from 'vue';
import App from './App.vue';
import store from './store';
import {
    TranslationPlugin,
    loadTranslations
} from './utils/translation';
import rolexTracking from './utils/rolexTracking';

// Import main SCSS file
import './assets/scss/main.scss';

// Disable Vue production tip
Vue.config.productionTip = false;

Vue.prototype.$rolexTracking = rolexTracking;

async function initApp() {
    // Get options from container element
    const container = document.getElementById('rolex-appointment-calendar');
    let options = {};
    if (container && container.dataset.options) {
        try {
            options = JSON.parse(container.dataset.options);
        } catch (e) {
            console.error('Error parsing options:', e);
        }
    }

    // carica le traduzioni
    await loadTranslations();

    Vue.use(TranslationPlugin);

    new Vue({
        el: '#app',
        store,
        render: h => h(App, {
            props: {
                options
            }
        }),
    });
}

initApp();